<mat-sidenav-container style="height:100%">
  <mat-sidenav mode="side" position="end" opened style="width:300px;">

    <div style="place-content: stretch flex-start; align-items: stretch; flex-direction: column; box-sizing: border-box; display: flex; gap: 20px">

      <div *ngFor="let email of selectedEmails">
        <mat-card appearance="outlined">
          <mat-card-header style="padding: 0 0 16px 0;">
            <mat-card-title>
              Email Detail
            </mat-card-title>
            <div style="flex: 1 1 0%; box-sizing: border-box;"></div>
            <div style="margin-top:-7px">
              <a mat-button color="primary" href="/review/doc-viewer?DocId={{getDocId(email)}}" target="DocViewer">View</a>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div style="flex-direction: column; box-sizing: border-box; display: flex;">
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch flex-start; align-items: stretch;">
                <div style="flex: 1 1 65px; box-sizing: border-box; max-width: 65px; min-width: 65px;" class="title">Title</div>
                <div class="value">{{getEmailTitle(email)}}</div>
              </div>
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: center flex-start; align-items: center; gap: 10px;">
                <div style="flex: 1 1 65px; box-sizing: border-box; max-width: 65px; min-width: 65px;" class="title">From</div>
                <div class="value">{{getEmailFrom(email)}}</div>
              </div>
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: center flex-start; align-items: center; gap: 10px;">
                <div style="flex: 1 1 65px; box-sizing: border-box; max-width: 65px; min-width: 65px;" class="title">To</div>
                <div class="value">{{getEmailTo(email)}}</div>
              </div>
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: center flex-start; align-items: center; gap: 10px;">
                <div style="flex: 1 1 65px; box-sizing: border-box; max-width: 65px; min-width: 65px;" class="title">Date Sent</div>
                <div class="value">{{getDateTimeSent(email)}}</div>
              </div>
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: center flex-start; align-items: center; gap: 10px;">
                <div style="flex: 1 1 65px; box-sizing: border-box; max-width: 65px; min-width: 65px;" class="title">Subject</div>
                <div class="value">{{getEmailSubject(email)}}</div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>

    <div style="place-content: stretch space-between; align-items: stretch; flex-direction: column; box-sizing: border-box; display: flex; gap: 20px;">
      <div></div>
      <div style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px;">
        <div></div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
          <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
            <div>Email Thread Group</div>

            <div style="flex-direction: row; box-sizing: border-box; display: flex; align-items: center;">
              <div *ngIf="selectedEmails.length === 2">
                <a mat-button href="/review/doc-viewer?DocId={{getDocId(selectedEmails[1])}}&DiffDocId={{getDocId(selectedEmails[0])}}" target="DocViewer">Compare</a>
              </div>

              <div *ngIf="emailThreadId">
                <a mat-button [routerLink]="['/review/browse']" [queryParams]="{ EmailThreadId: emailThreadId, SelectedDocIds: selectedDocIds }">Browse</a>
              </div>

              <button mat-icon-button [matMenuTriggerFor]="appMenu">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #appMenu="matMenu">
                <button mat-menu-item routerLink="/email-thread-groupings">Select Email Thread Group</button>
              </mat-menu>
            </div>
          </mat-toolbar>

          <div style="flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined" style="margin-bottom: 0;">
              <mat-card-content class="content">
                <div style="place-content: stretch flex-start; align-items: stretch; flex-flow: row wrap; box-sizing: border-box; display: flex;">
                  <svg id="emailThread" width="100%" height="500">
                    <svg:g *ngFor="let graphPoint of graph" attr.transform="translate({{graphPoint.rect.x*(width+margin)}},{{graphPoint.rect.y*(height+margin)}})">
                      <svg:g *ngIf="graphPoint.threadPresent" [ngClass]="{'email-selected': isSelected(graphPoint.thread),'email-hover': graphPoint.thread === hoverThread}" (mouseover)="hoverThread=graphPoint.thread" (mouseout)="hoverThread=null" (click)="onClick(graphPoint.thread)">
                        <svg:rect *ngIf="getDuplicateIndicator(graphPoint.thread)" x="5" y="5" attr.width="{{width}}" attr.height="{{height}}" rx="3" ry="3"></svg:rect>
                        <svg:rect attr.width="{{width}}" attr.height="{{height}}" rx="3" ry="3"></svg:rect>
                        <svg:circle [attr.fill]="getFillValue(graphPoint.thread)"
                                    [attr.visibility]="getVisibilityValue(graphPoint.thread)"
                                    cx="136" cy="12" r="5" stroke="green" stroke-width="2"></svg:circle>
                        <svg:text x="10" y="20" text-anchor="start" class="email-date-sent" fill="black">{{getDateSent(graphPoint.thread)}}</svg:text>
                        <svg:text x="10" y="40" text-anchor="start" class="email-time-sent">{{getTimeSent(graphPoint.thread)}}</svg:text>
                        <svg:text x="140" y="55" text-anchor="end" class="duplicate-email-number">{{getDuplicateIndicator(graphPoint.thread)}}</svg:text>
                      </svg:g>
                      <svg:g *ngIf="!graphPoint.threadPresent" class="email-not-available">
                        <svg:rect attr.width="{{width}}" attr.height="{{height}}" rx="3" ry="3" stroke-dasharray="5" style="stroke-width:1;"></svg:rect>
                        <svg:text x="75" y="35" text-anchor="middle">Not Available</svg:text>
                      </svg:g>
                      <svg:g *ngFor="let line of graphPoint.lines">
                        <svg:path attr.d="M{{width}},{{height/2}} C{{width+margin/2}},{{height/2}} {{width+margin/2}},{{line[1].y*(height+margin)+height/2}} {{width+margin}},{{line[1].y*(height+margin)+height/2}}" class="line" style="stroke-width:1;fill:none" />
                      </svg:g>
                    </svg:g>
                  </svg>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <div></div>
      </div>
    </div>

  </mat-sidenav-content>

</mat-sidenav-container>
